import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface PopupContextProps {
  isSaveOfferFormVisible: boolean;
  isResultPopupVisible: boolean;
  resultPopupHeader: string;
  resultPopupText: string;
  isCarouselVisible: boolean;
  carouselImages: string[];
  setIsSaveOfferFormVisible: (isSaveOfferFormVisible: boolean) => void;
  setIsResultPopupVisible: (isResultPopupVisible: boolean) => void;
  setResultPopupHeader: (resultPopupHeader: string) => void;
  setResultPopupText: (resultPopupText: string) => void;
  setIsCarouselVisible: (isCarouselVisible: boolean) => void;
  setCarouselImages: (images: string[]) => void;
}

const PopupContext = createContext<PopupContextProps | null>(null);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isSaveOfferFormVisible, setIsSaveOfferFormVisible] = useState(false);
  const [isResultPopupVisible, setIsResultPopupVisible] = useState(false);
  const [resultPopupHeader, setResultPopupHeader] = useState("");
  const [resultPopupText, setResultPopupText] = useState("");
  const [isCarouselVisible, setIsCarouselVisible] = useState(false);
  const [carouselImages, setCarouselImages] = useState<string[]>([]);

  return (
    <PopupContext.Provider
      value={{
        isSaveOfferFormVisible,
        isResultPopupVisible,
        resultPopupHeader,
        resultPopupText,
        setIsSaveOfferFormVisible,
        setIsResultPopupVisible,
        setResultPopupHeader,
        setResultPopupText,
        setIsCarouselVisible,
        isCarouselVisible,
        carouselImages,
        setCarouselImages,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = (): PopupContextProps => {
  const context = useContext(PopupContext);

  if (!context) {
    throw new Error("usePopup must be used within a ViewProvider");
  }

  return context;
};
